<template>
  <mdb-container>
    <mdb-btn v-if="loadReady" @click="addGameleoKeyword" color="indigo">{{
      $t("add_new_gameleokeyword")
    }}</mdb-btn>
    <DataTableAG
      :columns="columns"
      :getcontentpath="getgameleokeywordspath"
      jsonobject="gameleokeywords"
      :buttonList="['Muokkaa']"
      v-on:pressed-button1="editGameleoKeywords"
      :key="componentKey"
      width="1050px"
      height="750px"
    />
    <EditGameleoKeyword
      v-if="editGameleoKeywordModal"
      :modal-show="editGameleoKeywordModal"
      :keyword="keyword"
      :name="name"
      :price="price"
      :created="created"
      :duration="duration"
      :id="id"
      :add-gameleo-keyword-state="addGameleoKeywordState"
      v-on:modal-cancelled="editGameleoKeywordCancelled"
      v-on:modal-ok="editGameleoKeywordOk"
    />
  </mdb-container>
</template>

<script>
import EditGameleoKeyword from "@/components/EditGameleoKeyword.vue";
import DataTableAG from "@/components/DataTableAG.vue";
import { mdbBtn, mdbContainer } from "mdbvue";
export default {
  name: "GameleoKeywordChains",
  components: {
    mdbBtn,
    mdbContainer,
    EditGameleoKeyword,
    DataTableAG,
  },
  methods: {
    loadingReady() {
      this.loadReady = true;
    },
    editGameleoKeywordCancelled() {
      this.editGameleoKeywordModal = false;
    },
    editGameleoKeywordOk() {
      this.editGameleoKeywordModal = false;
      this.componentKey += 1;
    },
    editGameleoKeywords(rowData) {
      this.keyword = rowData.keyword;
      this.price = rowData.price;
      this.name = rowData.name;
      this.duration = rowData.duration;
      this.id = rowData.id;
      this.addGameleoKeywordState = false;
      this.editGameleoKeywordModal = true;
    },
    addGameleoKeyword() {
      this.keyword = "";
      this.name = "";
      this.price = 1499;
      this.duration = 12;
      this.addGameleoKeywordState = true;
      this.editGameleoKeywordModal = true;
    },
  },
  data: () => ({
    loadReady: false,
    editGameleoKeywordModal: false,
    addGameleoKeywordState: false,
    componentKey: 0,
    id: 0,
    keyword: "",
    name: "",
    price: 0,
    duration: 0,
    search: "",
    created: "",
    getgameleokeywordspath: "/1.0/front/gameleo/keywords",
    rows: [],
    columns: [
     {
        field: "name",
        headerName: "Nimi",
        width: 50,
        pinned: "left",
        sortable: true,
        filter: true,
      },
      {
        field: "keyword",
        headerName: "Hakusana",
        width: 125,
        pinned: "left",
        sortable: true,
        filter: true,
      },
      {
        field: "price",
        headerName: "Hinta",
        width: 100,
        pinned: "left",
        sortable: true,
        filter: true,
      },
      {
        field: "duration",
        headerName: "Kesto kuukausina",
        width: 175,
        pinned: "left",
        sortable: true,
        filter: true,
      },
      {
        field: "created",
        headerName: "Luomisajankohta",
        width: 175,
        pinned: "left",
        sortable: true,
        filter: true,
      },
      {
        field: "id",
        headerName: "IntId",
        width: 50,
        pinned: "left",
        sortable: true,
        filter: true,
      },
    ],
  }),
  mounted() {
    this.loadReady = true;
  },
};
</script>
